import styled from "styled-components"

export const HeaderContainer = styled.section`
  margin-bottom: 10px;
  padding: 10px;
`

export const MapContainer = styled.section`
  margin-bottom: 10px;
  padding: 10px 0;
`

export const DetailsContainer = styled.section`
  margin-bottom: 10px;
  padding: 10px;
`

export const GraphContainer = styled.section`
  margin-bottom: 10px;
  padding: 10px;
`